import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import { ANEEL_TARIFF_IMPORT_STATUS_OPTIONS, AneelTariffImportHistoryStatus } from "@/modules/common/types/AneelTariffs.enum";

export const ANEEL_TARIFF_IMPORT_HISTORY_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "status",
    label: "Status",
    type: "select",
    placement: "inline",
    schema: z.coerce.number().pipe(z.enum(AneelTariffImportHistoryStatus)),
    options: ANEEL_TARIFF_IMPORT_STATUS_OPTIONS,
  },
];
